export default __webpack_public_path__ + "static/flag_b.07c6f7a50dbcea09632c86611d0c06d8.svg";